import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
import {
  getHeaders,
  checkStatus,
} from "../../../Services/SharedSevices/SharedServices";
const baseURL = process.env.REACT_APP_BASE_URL;

// For add policy.
export const addPolicyData = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Policy/Add`,
      body,
      {
        headers: await getHeaders(),
        body: JSON.stringify(body),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getPolicyList = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Policy/List`,
      body,
      {
        headers: await getHeaders(),
        body: JSON.stringify(body),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
// Delete Policy by USER id.
export const deletePolicyList = async (body) => {
  try {
    const response = await axiosInstance.delete(
      `${baseURL}/Policy/Delete`,
      {
        headers: await getHeaders(),
        data: body,
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


export const publishedPolicy = async (params) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Policy/Publish?PolicyId=${params.PolicyId}&ModifiedBy=${params.ModifiedBy}`,
      JSON.stringify(params),
      {
        headers: await getHeaders()
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
